/*
 * Preggie Set-Auswahl auf der Produktseite
 * -------------------------------------------------------------
 * Gehoert zu 'preggie-pdp-bundle'. Der Block zeigt zwei
 * Angebote, dieses Skript haelt sie mit der Seite und dem
 * Warenkorb zusammen.
 *
 * Einzel: die Seite verhaelt sich unveraendert. Der Kaufbutton
 * legt die gewaehlte Variante des Produkts in den Warenkorb,
 * hier wird nichts abgefangen.
 *
 * Set: der Kaufbutton wird abgefangen und legt seit dem
 * 06.08.2026 EINE Zeile in den Warenkorb, die Variante des
 * Bundle-Produkts zu ihrem echten Preis. Die gewaehlten Artikel
 * haengen als Angaben daran und werden im Warenkorb von
 * 'preggie-bundle-lines' mit Bild und Namen aufgelistet. Der
 * Setpreis ist damit ein Variantenpreis und kein Rabatt mehr,
 * also unverdraengbar. Vorher kam er aus der Automatik "Set:
 * Wickelrucksack + Komfort-Still-BH", und weil Shopify Basic je
 * Warenkorbzeile nur einen Produktrabatt zulaesst, liessen ihn
 * schon zwei zusaetzliche Still-BHs wortlos wegfallen. Fehlt
 * das Bundle-Produkt, bleibt es bei zwei Zeilen mit der
 * versteckten Angabe _set und der Automatik.
 *
 * Die Farbauswahl des Hauptprodukts im Block und die
 * Variantenauswahl des Themes zeigen dasselbe an. Beide Wege
 * werden gespiegelt: eine Aenderung im Block wird an das
 * passende Bedienelement des Themes weitergereicht, eine
 * Aenderung am Theme liest der Block aus dem Formularfeld
 * "id" zurueck.
 *
 * Ausverkaufte Kombinationen des Partnerprodukts bleiben
 * sichtbar, werden aber beschriftet und gesperrt, damit der
 * Warenkorb-Aufruf nicht am ganzen Set scheitert. Wie das
 * bewertet wird, steht bei hasAvailableForPrefix.
 *
 * Focal rendert den Kaufbereich mehrfach (Hauptspalte,
 * Quick-Buy, Sticky-Leiste). Alle Kopien werden gespiegelt,
 * und der Sticky-Kaufbutton wird ebenso abgefangen, auch wenn
 * der Block dort gar nicht steht.
 *
 * Und Focal baut denselben Bereich bei jedem Variantenwechsel
 * komplett neu auf. Der Block wird dabei durch eine frische
 * Kopie ersetzt. Deshalb haengen die Zuhoerer fuer Absenden
 * und Variantenwechsel am Dokument und nicht an der einzelnen
 * Instanz, ausgetauschte Instanzen werden aussortiert, und die
 * getroffene Auswahl wandert in die neue Kopie. Siehe
 * lastChoice und livingInstances.
 *
 * Die Warenkorb-Anbindung folgt den Events, die Focal 12.5
 * selbst nutzt: variant:added, cart:updated, cart:refresh mit
 * der Section "mini-cart".
 */
(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-pset]';
  var SOLDOUT_SUFFIX = ' · ausverkauft';
  var instances = [];
  var mirroring = false;

  /* Focal baut den Kaufbereich bei jedem Variantenwechsel neu
     auf. Der alte Block fliegt dabei aus dem Dokument, seine
     Widget-Instanz lebt aber weiter und faengt den Kaufbutton
     weiter ab. Sie legt dann ihren alten Stand in den
     Warenkorb, waehrend die Seite laengst etwas anderes
     anzeigt. Gemessen am 06.08.2026: Farbwechsel am
     Wickelrucksack, die Anzeige sprang auf "Einzel" und
     Schwarz/S, im Warenkorb landete trotzdem ein Set mit
     Grau/2XL.

     Zwei Vorkehrungen dagegen. Erstens zaehlt eine Instanz nur
     mit, solange ihre Wurzel im Dokument steht, siehe
     livingInstances. Zweitens merkt sich lastChoice die
     zuletzt getroffene Auswahl, damit die neue Instanz sie
     uebernimmt statt bei "Einzel" und der ersten Variante
     wieder anzufangen. */
  var lastChoice = { key: null, mode: 'single', partner: null };
  var globalsBound = false;

  function livingInstances() {
    instances = instances.filter(function (instance) {
      return instance.root && document.contains(instance.root);
    });
    return instances;
  }

  function routeRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function themeSettings() {
    return (window.themeVariables && window.themeVariables.settings) || {};
  }

  function toArray(list) {
    return Array.prototype.slice.call(list);
  }

  function sameOptions(variantOptions, chosen) {
    if (!variantOptions || variantOptions.length !== chosen.length) return false;
    for (var i = 0; i < chosen.length; i++) {
      if (String(variantOptions[i]) !== String(chosen[i])) return false;
    }
    return true;
  }

  function findVariant(variants, chosen) {
    for (var i = 0; i < variants.length; i++) {
      if (sameOptions(variants[i].o, chosen)) return variants[i];
    }
    return null;
  }

  function hasAvailable(variants, chosen) {
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].a && sameOptions(variants[i].o, chosen)) return true;
    }
    return false;
  }

  /* Ein Optionswert gilt als kaufbar, sobald es irgendeine
     kaufbare Variante gibt, die zu den Auswahlen LINKS davon
     passt. Was rechts davon steht, zaehlt bewusst nicht mit.

     Sonst sperrt eine bereits gewaehlte Groesse eine ganze Farbe
     weg, obwohl es die Farbe in einer anderen Groesse sehr wohl
     gibt, und die Kundin kommt nie an diese Kombination heran.
     Aufgefallen am 05.08.2026 an den Schwangerschafts Leggings,
     die es in Hellbraun nur in L gibt. Gleiche Korrektur in
     preggie-bundle.js und preggie-qty-tiers.js. */
  function hasAvailableForPrefix(variants, chosen, index, value) {
    for (var i = 0; i < variants.length; i++) {
      var variant = variants[i];
      if (!variant.a || !variant.o) continue;
      if (String(variant.o[index]) !== String(value)) continue;

      var matches = true;
      for (var j = 0; j < index; j++) {
        if (String(variant.o[j]) !== String(chosen[j])) { matches = false; break; }
      }
      if (matches) return true;
    }
    return false;
  }

  /* Sperrt und beschriftet alles, was mit den Auswahlen links
     davon nicht kaufbar ist. */
  function markAvailability(selects, variants) {
    var chosen = selects.map(function (select) { return select.value; });

    selects.forEach(function (select, index) {
      toArray(select.options).forEach(function (option) {
        var available = hasAvailableForPrefix(variants, chosen, index, option.value);
        option.disabled = !available;
        option.textContent = available ? option.value : option.value + SOLDOUT_SUFFIX;
      });
    });
  }

  /* Faellt die aktuelle Kombination aus, wird auf die naechste
     kaufbare umgestellt. Von links nach rechts bleibt dabei so
     viel stehen wie moeglich, der zuerst gewaehlte Wert, meist
     die Farbe, hat also Vorrang. */
  function fixSelection(selects, variants) {
    if (!selects.length) return;
    var chosen = selects.map(function (select) { return select.value; });
    if (hasAvailable(variants, chosen)) return;

    for (var keep = chosen.length - 1; keep >= 0; keep--) {
      for (var i = 0; i < variants.length; i++) {
        var variant = variants[i];
        if (!variant.a || !variant.o) continue;

        var matches = true;
        for (var j = 0; j < keep; j++) {
          if (String(variant.o[j]) !== String(chosen[j])) { matches = false; break; }
        }
        if (!matches) continue;

        for (var k = 0; k < selects.length; k++) {
          if (variant.o[k] != null) selects[k].value = variant.o[k];
        }
        return;
      }
    }
  }

  function setImages(nodes, source) {
    if (!source) return;
    nodes.forEach(function (img) {
      if (img.getAttribute('src') !== source) {
        img.setAttribute('src', source);
        img.removeAttribute('srcset');
      }
    });
  }

  function Widget(root) {
    this.root = root;
    this.data = this.readData();
    if (!this.data) return;

    this.singleIds = (root.getAttribute('data-single-ids') || '')
      .split(',')
      .map(function (id) { return id.trim(); })
      .filter(Boolean);

    this.modeInputs = toArray(root.querySelectorAll('[data-pset-mode]'));
    this.singleSelects = toArray(root.querySelectorAll('[data-pset-single-option]'));
    this.partnerSelects = toArray(root.querySelectorAll('[data-pset-partner-option]'));
    this.singleThumbs = toArray(root.querySelectorAll('[data-pset-single-thumb]'));
    this.partnerThumbs = toArray(root.querySelectorAll('[data-pset-partner-thumb]'));
    this.singlePrices = toArray(root.querySelectorAll('[data-pset-single-price]'));

    this.busy = false;
    instances.push(this);
    this.init();
  }

  Widget.prototype.readData = function () {
    var node = this.root.querySelector('[data-pset-data]');
    if (!node) return null;
    try {
      var data = JSON.parse(node.textContent);
      if (!data || !data.single || !data.partner) return null;
      return data;
    } catch (e) {
      return null;
    }
  };

  Widget.prototype.mode = function () {
    for (var i = 0; i < this.modeInputs.length; i++) {
      if (this.modeInputs[i].checked) return this.modeInputs[i].getAttribute('data-pset-mode');
    }
    return 'single';
  };

  /* Die Auswahlfelder liegen innerhalb der Beschriftung. Ein
     Klick darauf darf die Karte nicht umschalten. Laut Standard
     tut er das ohnehin nicht, aeltere WebKit-Versionen halten
     sich aber nicht daran. */
  function shieldControl(el) {
    ['click', 'pointerdown', 'mousedown', 'touchstart'].forEach(function (type) {
      el.addEventListener(type, function (event) { event.stopPropagation(); });
    });
  }

  Widget.prototype.init = function () {
    var self = this;

    this.singleSelects.concat(this.partnerSelects).forEach(shieldControl);

    this.modeInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        if (!input.checked) return;
        lastChoice.key = self.singleIds.join(',');
        lastChoice.mode = input.getAttribute('data-pset-mode');
        self.mirrorMode(input.getAttribute('data-pset-mode'));
      });
    });

    this.singleSelects.forEach(function (select) {
      select.addEventListener('change', function () {
        self.applySingle(select.value, select.getAttribute('data-option-position'));
      });
    });

    this.partnerSelects.forEach(function (select) {
      select.addEventListener('change', function () {
        self.refreshPartner();
        self.mirrorPartner();
      });
    });

    this.restoreChoice();
    this.refreshSingle();
    this.refreshPartner();
  };

  /* Uebernimmt die Auswahl, die vor einem Neuaufbau des
     Kaufbereichs galt. Ohne das faellt die Seite bei jedem
     Farbwechsel am Hauptprodukt auf "Einzel" und die erste
     Variante des Partnerartikels zurueck, obwohl die Kundin
     das Set und ihre Groesse laengst gewaehlt hat. */
  Widget.prototype.restoreChoice = function () {
    if (lastChoice.key !== this.singleIds.join(',')) return;
    var values = lastChoice.partner;

    if (values && values.length === this.partnerSelects.length) {
      this.partnerSelects.forEach(function (select, index) {
        var value = values[index];
        if (value == null) return;
        for (var i = 0; i < select.options.length; i++) {
          if (select.options[i].value === value) {
            select.value = value;
            return;
          }
        }
      });
    }

    if (lastChoice.mode !== 'set') return;
    this.modeInputs.forEach(function (input) {
      if (input.getAttribute('data-pset-mode') === 'set') input.checked = true;
    });
  };

  /* Ein Satz Zuhoerer fuer das ganze Dokument statt einem je
     Instanz. Wer zustaendig ist, entscheidet sich erst beim
     Ereignis, damit immer die Instanz antwortet, die in diesem
     Augenblick wirklich auf der Seite steht. */
  function bindGlobals() {
    if (globalsBound) return;
    globalsBound = true;

    /* Aenderungen an der Variantenauswahl des Themes
       zurueckspiegeln. Das Formularfeld "id" ist die
       verlaesslichste Quelle, es steht nach jedem Wechsel
       richtig. */
    document.addEventListener('change', function (event) {
      if (mirroring) return;
      var target = event.target;
      if (!target || !target.closest) return;
      if (target.closest(ROOT_SELECTOR)) return;
      var form = target.form || target.closest('form');
      if (!form) return;
      window.setTimeout(function () {
        livingInstances().forEach(function (instance) {
          if (instance.isSingleForm(form)) instance.syncFromForm(form);
        });
      }, 0);
    });

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || form.tagName !== 'FORM') return;

      var widget = null;
      livingInstances().forEach(function (instance) {
        if (widget) return;
        if (instance.isSingleForm(form) && instance.mode() === 'set') widget = instance;
      });
      if (!widget) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      widget.submitSet(form);
    }, true);
  }

  Widget.prototype.isSingleForm = function (form) {
    if (!form.action || form.action.indexOf('/cart/add') === -1) return false;
    var idInput = form.querySelector('[name="id"]');
    if (!idInput) return false;
    return this.singleIds.indexOf(String(idInput.value)) !== -1;
  };

  Widget.prototype.forms = function () {
    var self = this;
    return toArray(document.querySelectorAll('form[action*="/cart/add"]')).filter(function (form) {
      return self.isSingleForm(form);
    });
  };

  /* Setzt einen Optionswert im Block und reicht ihn an das
     Bedienelement des Themes weiter. */
  Widget.prototype.applySingle = function (value, position) {
    if (mirroring) return;
    var self = this;
    mirroring = true;

    try {
      livingInstances().forEach(function (instance) {
        instance.singleSelects.forEach(function (select) {
          if (select.getAttribute('data-option-position') === String(position) && select.value !== value) {
            select.value = value;
          }
        });
      });

      this.forms().forEach(function (form) { self.pushToTheme(form, position, value); });
    } finally {
      mirroring = false;
    }

    livingInstances().forEach(function (instance) { instance.refreshSingle(); });
  };

  /* Gehoert das Bedienelement zu dieser Option? Focal setzt
     data-option-position, aeltere Staende nur den Namen. */
  function belongsToOption(el, position) {
    var attr = el.getAttribute('data-option-position');
    if (attr) return attr === String(position);
    return el.name === 'option' + position;
  }

  /* Der sichtbare Wert eines Bedienelements. Farbfelder tragen
     im value die ID des Optionswerts, der lesbare Name steht
     in der zugehoerigen Beschriftung. */
  function optionValueOf(el, index) {
    if (el.tagName === 'SELECT') {
      var option = el.options[index != null ? index : el.selectedIndex];
      return option ? (option.textContent || '').trim() : '';
    }
    if (el.id) {
      var label = document.querySelector('label[for="' + (window.CSS && CSS.escape ? CSS.escape(el.id) : el.id) + '"]');
      if (label) return (label.textContent || '').trim();
    }
    var wrapping = el.closest('label');
    if (wrapping) return (wrapping.textContent || '').trim();
    return el.value;
  }

  /* Sucht im Formular das Bedienelement, das diesen Wert
     anbietet, und loest dort eine Aenderung aus. Die
     Variantenauswahl haengt in Focal ueber das Attribut "form"
     am Formular und nicht im Formular, deshalb form.elements
     statt querySelectorAll. Findet sich nichts, wird das
     Formularfeld "id" direkt gesetzt. */
  Widget.prototype.pushToTheme = function (form, position, value) {
    var controls = form.elements ? toArray(form.elements) : [];
    var i;
    var j;

    for (i = 0; i < controls.length; i++) {
      var radio = controls[i];
      if (radio.type !== 'radio' || radio.closest(ROOT_SELECTOR)) continue;
      if (!belongsToOption(radio, position)) continue;
      if (optionValueOf(radio) !== value && radio.value !== value) continue;
      if (!radio.checked) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return true;
    }

    for (i = 0; i < controls.length; i++) {
      var select = controls[i];
      if (select.tagName !== 'SELECT' || select.closest(ROOT_SELECTOR)) continue;
      if (!belongsToOption(select, position)) continue;
      for (j = 0; j < select.options.length; j++) {
        if (optionValueOf(select, j) !== value && select.options[j].value !== value) continue;
        if (select.selectedIndex !== j) {
          select.selectedIndex = j;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return true;
      }
    }

    var chosen = this.currentSingleValues();
    var variant = findVariant(this.data.single.vars, chosen);
    var idInput = form.querySelector('[name="id"]');
    if (variant && idInput && String(idInput.value) !== String(variant.id)) {
      idInput.value = variant.id;
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
    return false;
  };

  /* Liest die vom Theme gewaehlte Variante zurueck. */
  Widget.prototype.syncFromForm = function (form) {
    var idInput = form.querySelector('[name="id"]');
    if (!idInput) return;
    var variant = null;
    var vars = this.data.single.vars;
    for (var i = 0; i < vars.length; i++) {
      if (String(vars[i].id) === String(idInput.value)) { variant = vars[i]; break; }
    }
    if (!variant) return;

    this.singleSelects.forEach(function (select) {
      var index = parseInt(select.getAttribute('data-option-position'), 10) - 1;
      var value = (variant.o || [])[index];
      if (value != null && select.value !== value) select.value = value;
    });

    this.refreshSingle();
  };

  Widget.prototype.currentSingleValues = function () {
    var byPosition = {};
    this.singleSelects.forEach(function (select) {
      byPosition[select.getAttribute('data-option-position')] = select.value;
    });
    return Object.keys(byPosition)
      .sort(function (a, b) { return a - b; })
      .map(function (key) { return byPosition[key]; });
  };

  Widget.prototype.refreshSingle = function () {
    var vars = this.data.single.vars;
    var chosen = this.currentSingleValues();
    var variant = chosen.length ? findVariant(vars, chosen) : vars[0];
    if (!variant) return;

    this.singleVariant = variant;
    setImages(this.singleThumbs, variant.img);
    this.singlePrices.forEach(function (node) {
      if (variant.p) node.textContent = variant.p;
    });
  };

  Widget.prototype.refreshPartner = function () {
    var vars = this.data.partner.vars;
    if (this.partnerSelects.length) {
      fixSelection(this.partnerSelects, vars);
      markAvailability(this.partnerSelects, vars);
    }
    var chosen = this.partnerSelects.map(function (select) { return select.value; });
    if (chosen.length) {
      lastChoice.key = this.singleIds.join(',');
      lastChoice.partner = chosen.slice();
    }

    var variant = chosen.length ? findVariant(vars, chosen) : vars[0];
    if (!variant) return;

    this.partnerVariant = variant;
    setImages(this.partnerThumbs, variant.img);
  };

  Widget.prototype.mirrorMode = function (mode) {
    if (mirroring) return;
    mirroring = true;
    livingInstances().forEach(function (other) {
      other.modeInputs.forEach(function (input) {
        if (input.getAttribute('data-pset-mode') === mode && !input.checked) {
          input.checked = true;
        }
      });
    });
    mirroring = false;
  };

  Widget.prototype.mirrorPartner = function () {
    if (mirroring) return;
    var self = this;
    var values = this.partnerSelects.map(function (select) { return select.value; });
    mirroring = true;
    livingInstances().forEach(function (other) {
      if (other === self) return;
      other.partnerSelects.forEach(function (select, index) {
        if (values[index] != null && select.value !== values[index]) select.value = values[index];
      });
      other.refreshPartner();
    });
    mirroring = false;
  };

  Widget.prototype.quantity = function (form) {
    var input = form.querySelector('[name="quantity"]');
    var value = input ? parseInt(input.value, 10) : 1;
    return value > 0 ? value : 1;
  };

  Widget.prototype.submitSet = function (form) {
    var self = this;
    if (this.busy) return;

    var singleVariant = this.singleVariant || this.data.single.vars[0];
    var partnerVariant = this.partnerVariant || this.data.partner.vars[0];
    if (!singleVariant || !partnerVariant) return;

    /* Seit dem 06.08.2026 kauft das Set eine einzige Zeile,
       naemlich die Variante des Bundle-Produkts zu ihrem echten
       Preis. Die gewaehlten Artikel haengen als Angaben daran,
       sichtbar als "Name: Auswahl", dazu ihre Varianten-IDs
       unter _artikel_ids fuers Lager. Der Warenkorb zeigt sie
       darunter mit Bild und Namen, das erledigt
       'preggie-bundle-lines' ueber das Metafeld
       bundle.components des Bundle-Produkts.

       Warum die Umstellung: der Setpreis kam vorher aus der
       Rabattautomatik "Set: Wickelrucksack + Komfort-Still-BH".
       Shopify Basic laesst je Warenkorbzeile nur einen
       Produktrabatt zu und vergibt sonst den groesseren. Schon
       zwei zusaetzliche Still-BHs liessen die beworbenen 109,95
       deshalb wortlos wegfallen. Ein echter Variantenpreis
       kollidiert mit keiner Staffel.

       Fehlt das Bundle-Produkt im JSON, etwa weil es nicht
       kaufbar ist, bleibt es bei der alten Bauweise mit zwei
       Zeilen und der Rabattautomatik. */
    var quantity = this.quantity(form);
    var bundle = this.data.bundle;
    var items;

    if (bundle && bundle.id) {
      var properties = {};
      var labels = bundle.labels || [];
      var singleLabel = labels[0] || 'Artikel 1';
      var partnerLabel = labels[1] || 'Artikel 2';

      properties[singleLabel] = this.currentSingleValues().join(' / ');
      properties[partnerLabel] = this.partnerSelects.map(function (select) {
        return select.value;
      }).join(' / ');
      properties._artikel_ids = singleVariant.id + ',' + partnerVariant.id;

      items = [{ id: bundle.id, quantity: quantity, properties: properties }];
    } else {
      var group = singleVariant.id + '-' + partnerVariant.id;
      items = [
        { id: singleVariant.id, quantity: quantity, properties: { _set: group } },
        { id: partnerVariant.id, quantity: quantity, properties: { _set: group } }
      ];
    }

    this.busy = true;
    var buttons = toArray(form.querySelectorAll('[type="submit"]'));
    buttons.forEach(function (button) { button.setAttribute('aria-busy', 'true'); });
    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

    var root = routeRoot();
    var settings = themeSettings();

    var done = function () {
      self.busy = false;
      buttons.forEach(function (button) { button.removeAttribute('aria-busy'); });
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
    };

    fetch(root + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items, sections: ['mini-cart'] })
    }).then(function (response) {
      return response.json().then(function (json) { return { ok: response.ok, json: json }; });
    }).then(function (result) {
      if (!result.ok) {
        done();
        form.dispatchEvent(new CustomEvent('cart:error', {
          bubbles: true,
          detail: { error: result.json && result.json.description }
        }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        return;
      }

      if (settings.cartType === 'page' || settings.pageType === 'cart') {
        window.location.href = root + 'cart';
        return;
      }

      var added = result.json.items ? result.json.items[0] : result.json;
      form.dispatchEvent(new CustomEvent('variant:added', { bubbles: true, detail: { variant: added } }));

      return fetch(root + 'cart.js').then(function (response) {
        return response.json();
      }).then(function (cart) {
        document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
        cart.sections = result.json.sections;
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: {
            cart: cart,
            openMiniCart: settings.cartType === 'drawer' && form.closest('.drawer') === null
          }
        }));
        done();
      });
    }).catch(function () {
      done();
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    });
  };

  function boot() {
    bindGlobals();
    livingInstances();
    toArray(document.querySelectorAll(ROOT_SELECTOR)).forEach(function (root) {
      if (root.getAttribute('data-pset-ready') === '1') return;
      root.setAttribute('data-pset-ready', '1');
      new Widget(root);
    });
  }

  /* Focal tauscht den Kaufbereich beim Variantenwechsel selbst
     aus und meldet das nicht immer ueber shopify:section:load.
     Der Beobachter sorgt dafuer, dass ein neu eingehaengter
     Block trotzdem sofort bedient wird. */
  if (window.MutationObserver) {
    new MutationObserver(function () {
      for (var i = 0; i < instances.length; i++) {
        if (!document.contains(instances[i].root)) { boot(); return; }
      }
      var roots = document.querySelectorAll(ROOT_SELECTOR);
      for (var j = 0; j < roots.length; j++) {
        if (roots[j].getAttribute('data-pset-ready') !== '1') { boot(); return; }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:block:select', boot);
})();